module.exports = __webpack_public_path__ + "img/Weapon_235.fa7f6ed4.png";